module.exports = __webpack_public_path__ + "static/media/icomoon.1f638443.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/_assets/fonts/icomoon.ttf
// module id = 1447
// module chunks = 1